import { Injectable } from '@angular/core';
import { SecurityService } from '../system/security.service';
import { Employee } from '@shared/classes/employee.class';
import { SecuredResponse } from '@shared/classes/secured-response.class';
import { SERVER_CONFIG } from '@shared/constants/server.const';

@Injectable()
export class EmployeesApiService {
  private readonly endpoint = 'employees/';
  constructor(private SecurityService: SecurityService) {}

  public getCurrentUser() {
    return this.SecurityService.doSecureRequest(`${SERVER_CONFIG.API_URL}${this.endpoint}current`, 'get', null).then(
      (response: SecuredResponse) => new Employee(response?.data?.properties)
    );
  }
}
